module.exports = __webpack_public_path__ + "img/alignxcel.5cb54228.svg";